import { useState } from "react";
import { Outlet } from "react-router-dom";
import { DirectoryProvider } from "../../components/select/directory/DirectoryContext";
import SideBarOrganization from "../../components/sideBar/SideBarOrganization";
import { MenuProvider } from "../../context/MenuContext";
import { useSideBarStore } from "../../store/SideBarStore";
import { ConversationMenu } from "./ConversationMenu";

const ConversationLayout = () => {
  const { isOrganizationSideBar } = useSideBarStore((state) => state);
  const [orgList, setOrgList] = useState([]);

  return (
    <MenuProvider>
      <div className="flex">
        <DirectoryProvider
          orgList={orgList}
          setOrgList={setOrgList}
          isOpen={isOrganizationSideBar}
        >
          <SideBarOrganization />
        </DirectoryProvider>
        <ConversationMenu />
        <Outlet />
      </div>
    </MenuProvider>
  );
};

export default ConversationLayout;
